import * as React from 'react';
import styled from 'styled-components';
import {
	blackColour,
	brandingColourHeavy,
	brandingColourLight,
	phoneOnlyMaxWidth,
	tabletPortraitMinWidth
} from '../../../cssConstants';

const PublicInstructionSteps = ({ steps }: { steps: string[] }) => {
	return (
		<>
			<StepTitle>Get started in {steps.length} simple steps.</StepTitle>
			<StepsContainer>
				{steps.map((step, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<Step key={index}>
						<StepNumberContainer>
							<StepNumber>{index + 1}</StepNumber>
						</StepNumberContainer>
						<StepText>{step}</StepText>
						{index !== steps.length - 1 && <DottedLine />}
					</Step>
				))}
			</StepsContainer>
		</>
	);
};

export default PublicInstructionSteps;

const StepTitle = styled.p`
	text-align: left;
	font-weight: 500;
	color: ${blackColour};
	font-size: 16px;
	margin: 15px 0px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 20px;
		margin: 20px 0px;
	}
`;

const StepsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`;

const Step = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	margin-bottom: 30px;
`;

const StepNumberContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	background-color: ${brandingColourHeavy};
	border-radius: 50%;
	color: white;
	font-weight: bold;
	font-size: 16px;
	flex-shrink: 0;

	@media (max-width: ${phoneOnlyMaxWidth}) {
		width: 30px;
		height: 30px;
		font-size: 14px;
	}
`;

const StepNumber = styled.span`
	color: white;
`;

const StepText = styled.p`
	margin-left: 20px;
	font-size: 18px;
	color: ${blackColour};

	@media (max-width: ${phoneOnlyMaxWidth}) {
		margin-left: 10px;
		font-size: 16px;
	}
`;

const DottedLine = styled.div`
	position: absolute;
	left: 20px;
	bottom: -30px;
	width: 2px;
	height: 30px;
	background-color: transparent;
	border-left: 2px dotted ${brandingColourLight};

	@media (max-width: ${phoneOnlyMaxWidth}) {
		left: 15px;
		bottom: -20px;
		height: 20px;
	}
`;
